import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommsSliceState {
  unreadChatV2: boolean;
}

const initialState: CommsSliceState = {
  unreadChatV2: false,
};

export const commsSlice = createSlice({
  name: 'comms',
  initialState,
  reducers: {
    setUnreadChatV2: (state, action: PayloadAction<boolean>) => {
      state.unreadChatV2 = action.payload;
    },
  },
});

export const { setUnreadChatV2 } = commsSlice.actions;

export default commsSlice.reducer;
